<template>
  <div>
    <main-header ref="permissions-header" :headerPrimaryName="`Coding / User Permissions ${headerPrimaryName ? '/ ' + headerPrimaryName : ''}`" :headerSecondaryName="headerSecondaryName" />
    <load-content :loading="isReady == false">
      <div ref="permissions-content" class="main-content">
        <router-view @setHeaderPrimaryName="onSetHeaderPrimaryName" @setHeaderSecondaryName="onSetHeaderSecondaryName" />
      </div>
    </load-content>
  </div>
</template>

<script>
import LoadContent from '@/components/load-content';
import MainHeader from '@/layouts/main-header';
import setMarginTop from '@/helpers/setMarginTop.js';

export default {
  data: function() {
    return {
      headerPrimaryName: '',
      headerSecondaryName: null,
      isReady: true
    }
  },

  mounted: function(){
    this.$nextTick(() => {
        this.setMarginTopMain();
        window.addEventListener("resize", this.setMarginTopMain);
    })
  },

  beforeDestroy: function(){  
    window.removeEventListener("resize", this.setMarginTopMain);
  },

  methods: {
    onSetHeaderPrimaryName: function(value) {
      this.headerPrimaryName = value;
    },

    onSetHeaderSecondaryName: function(value) {
      this.headerSecondaryName = value;
    },

     setMarginTopMain(e){      
      const mainHeader = this.$refs["permissions-header"];
      const mainContent = this.$refs["permissions-content"];      
      mainHeader && (mainHeader.$el && mainHeader.$el.childNodes.length) && mainContent && setMarginTop(mainHeader.$el, mainContent, 0);
    },
  },

  components: {
    MainHeader,
    LoadContent
  }
};
</script>